import { Tag } from "antd";

export const STATUS_LABELS = {
  pendente: { label: "Pendente", color: "default" },
  executando: { label: "Executando", color: "processing" },
  concluido: { label: "Concluído", color: "success" },
  falhou: { label: "Falhou", color: "error" },
  recusado: { label: "Recusado", color: "warning" },
  bloqueado_guardrail: { label: "Bloqueado (guardrail)", color: "error" },
  cancelado: { label: "Cancelado", color: "default" },
  sem_dados: { label: "Sem dados", color: "default" },
};

export const STATUS_ATIVOS = ["pendente", "executando"];

export const DELIVERY_STATUS_LABELS = {
  nao_enviada: { label: "Não enviada", color: "default" },
  pendente: { label: "Enviando", color: "processing" },
  parcial: { label: "Parcial", color: "warning" },
  enviada: { label: "Aceita pelo webhook", color: "success" },
  falhou: { label: "Falhou", color: "error" },
};

export const DELIVERY_STATUS_ATIVOS = ["pendente", "parcial"];

export const DELIVERY_ITEM_LABELS = {
  pendente: { label: "Pendente", color: "default" },
  enviando: { label: "Enviando", color: "processing" },
  enviado: { label: "Aceito pelo webhook", color: "success" },
  falhou: { label: "Falhou", color: "error" },
};

export const VERSION_STATUS_LABELS = {
  draft: { label: "Rascunho", color: "default" },
  published: { label: "Publicada", color: "success" },
  retired: { label: "Aposentada", color: "warning" },
};

export function StatusTag({ status, mapa = STATUS_LABELS }) {
  const item = mapa[status] || { label: status, color: "default" };
  return <Tag color={item.color}>{item.label}</Tag>;
}

export function formatDateTime(value) {
  if (!value) return "—";
  const data = new Date(value);
  return data.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDate(value) {
  if (!value) return "—";
  const [ano, mes, dia] = value.split("-");
  return `${dia}/${mes}/${ano}`;
}

export function formatUsd(value) {
  if (value === null || value === undefined) return "—";
  return `US$ ${Number(value).toFixed(4)}`;
}

export function describeError(err, fallback) {
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;
  if (typeof data === "string") return data;
  if (data.error) return data.error;
  if (data.detail) return data.detail;
  return Object.entries(data)
    .map(([campo, msgs]) => `${campo}: ${[].concat(msgs).join(" ")}`)
    .join(" | ");
}
